import { Component } from '@angular/core';
import { RouterOutlet, } from '@angular/router';
import { HeaderComponent } from "./views/header/header.component";
import { FooterComponent } from "./views/footer/footer.component";

@Component({
  selector: 'pil-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  template: `
    <pil-header />
    <main>
      <router-outlet />
    </main>
    <pil-footer />
  `,
  styles: [`
    main { }
  `]
})
export class AppComponent {}
